export default "__VITE_ASSET__Oc7kmD6K__"